<template>
    <el-dialog
        width="1000px"
        top="5vh"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        class="process-dialog"
    >
        <div class="dialog-header">
            <div class="text">发起流程</div>
            <div class="close-btn" @click="closeDialog">
                <i class="el-icon el-icon-close"></i>
            </div>
        </div>
        <div class="dialog-body">
            <div class="aside">
                <div class="title">快速发起</div>
                <div class="items">
                    <el-collapse v-model="collapseActiveNames" accordion>
                        <el-collapse-item name="1">
                            <template slot="title">
                                <i class="el-icon-time"></i><span class="collapse-title">最近使用</span>
                            </template>
                            <template v-if="fastProcessData.length > 0">
                                <div
                                    v-for="(item, index) of fastProcessData"
                                    :key="index"
                                    :title="item.name"
                                    :class="[{ isActive: item.isActive }, 'item']"
                                    @click="handleFastClick(item)"
                                >
                                    {{ item.name }}
                                </div>
                            </template>
                            <template v-else>
                                <div class="empty-data">暂无数据</div>
                            </template>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </div>
            <div class="main">
                <div class="right-title">
                    <div class="text">按分类发起</div>
                    <div class="search">
                        <el-input
                            v-model="keyword"
                            placeholder="流程名称"
                            size="mini"
                            clearable
                            :style="{ width: '200px' }"
                            prefix-icon="el-icon-search"
                            @keyup.enter.native="handleSearch"
                        ></el-input>
                    </div>
                </div>
                <div class="container">
                    <div class="left-side">
                        <div class="items">
                            <template v-for="(item, index) of classifyData">
                                <div
                                    :key="index"
                                    :class="[{ isActive: item.isActive }, 'item']"
                                    @click="handleClassifyClick(item)"
                                >
                                    {{ item.name }}
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="right-side">
                        <!-- <el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick"></el-tree> -->
                        <el-tree node-key="id" :data="treeData" :props="defaultProps" @node-click="handleNodeClick">
                            <template slot-scope="{ node, data }">
                                <div class="tree-current-title">
                                    <i v-if="data.isProcess" class="title-prefix-icon process-icon"></i>
                                    <i v-else class="title-prefix-icon file-icon"></i>
                                    <span v-html="treeLabelFormat(data)"></span>
                                </div>
                            </template>
                        </el-tree>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { getRecentProcess, getProcessTree, getProcessUrlById, saveRecentProcess } from "@/api";
import { getLocalStorage } from "@/libs/mUtils";
export default {
    name: "ProcessDialog",
    components: {},
    props: {},
    data() {
        return {
            dialogVisible: false,
            collapseActiveNames: "1",
            keyword: "",
            fastProcessData: [], // 快速发起
            classifyData: [], // 流程分类
            treeData: [],
            clickNodeUrl: "", // 当前点击子节点的url
            classifyId: "", // 当前点击的分类id
            defaultProps: {
                children: "children",
                label: "name",
            },
        };
    },
    watch: {
        keyword: {
            handler() {
                this.handleSearch();
            },
            immediate: true, // 其值是true或false；确认是否以当前的初始值执行handler的函数。
        },
    },
    methods: {
        show() {
            this.dialogVisible = true;
            this.loadRecentProcess();
            this.loadProcessTree();
        },

        // 加载分类
        loadProcessTree() {
            let params = {};
            this.treeData = [];
            this.classifyData = [];
            if (this.keyword) {
                params.processName = this.keyword;
            }
            getProcessTree(params).then((res) => {
                if (res.status) {
                    this.processTreeDataConversion(res.body);
                }
            });
        },

        processTreeDataConversion(datas) {
            if (datas.length === 0) {
                return;
            }
            let newArray = [];
            let defaultExpandNode = null;
            datas.forEach((ele) => {
                let obj = {
                    id: ele.id,
                    url: ele.url,
                    isActive: false,
                    name: ele.name,
                    ifNbpm: ele.ifNbpm,
                    children: ele.children,
                };
                newArray.push(obj);
                if (!defaultExpandNode && ele.children.length > 0) {
                    defaultExpandNode = ele;
                }
            });
            this.classifyData = newArray;
            // 设置默认展开的节点
            if (defaultExpandNode) {
                this.handleClassifyClick(defaultExpandNode);
            } else {
                this.treeData = [];
            }
        },

        // 加载最近流程
        loadRecentProcess() {
            getRecentProcess().then((res) => {
                if (res.status) {
                    this.recentProcessDataConversion(res.body);
                }
            });
        },

        // 接口数据映射
        recentProcessDataConversion(data) {
            if (data.length === 0) {
                return;
            }
            this.fastProcessData = [];
            data.forEach((ele) => {
                let obj = {
                    id: ele.id,
                    url: ele.url,
                    isActive: false,
                    name: ele.processName,
                    ifNbpm: ele.ifNbpm,
                };
                this.fastProcessData.push(obj);
            });
        },

        handleSearch() {
            this.loadProcessTree();
        },
        // 快速发起点击事件
        handleFastClick(item) {
            item.isActive = true;
            let params = {
                id: item.id,
                isProcess: true,
            };
            getProcessUrlById(params).then((res) => {
                this.pageRedirect(item.id, item.ifNbpm, res.body);
            });
        },
        // 流程分类点击事件
        handleClassifyClick(item) {
            this.classifyId = item.id;
            this.classifyData.forEach((ele) => {
                ele.isActive = false;
                if (ele.id === item.id) {
                    ele.isActive = true;
                    this.treeData = ele.children;
                }
            });
            if (item.children.length > 0) {
                return;
            }
            let params = { id: item.id, isProcess: false };
            getProcessUrlById(params).then((res) => {
                this.pageRedirect(item.id, item.ifNbpm, res.body);
            });
        },
        // tree节点点击事件
        handleNodeClick(node) {
            // 不是流程数据，或者 当前节点有子级
            if (node.children.length > 0) {
                return;
            }
            let params = { id: node.id, isProcess: node.isProcess };
            getProcessUrlById(params).then((res) => {
                this.pageRedirect(node.id, node.ifNbpm, res.body);
            });
        },
        // 页面重定向
        pageRedirect(id, ifNbpm, url) {
            if (!url) {
                return;
            }
            this.saveRecentProcess(id);
            url = url + "&token=" + getLocalStorage("user").oauth.access_token;
            if (ifNbpm) {
                this.$router.push({ name: "iframeApp", query: { url: url } });
            } else {
                window.open(url);
            }
        },
        // 保存点击的流程数据
        saveRecentProcess(id) {
            let params = {
                username: getLocalStorage("user").oauth.userName || "",
                powerProcessId: id,
            };
            saveRecentProcess(params).then((res) => {
                if (res.status) {
                    this.closeDialog();
                }
            });
        },
        // tree 高亮匹配
        treeLabelFormat(data) {
            if (data.name.includes('<span style="color:#3A9D80">')) {
                data.name = data.name.replace('<span style="color:#3A9D80">', "");
                data.name = data.name.replace("</span>", "");
            }
            if (!this.keyword) {
                return data.name;
            }
            if (data.name.includes(this.keyword)) {
                return data.name.replace(this.keyword, `<span style="color:#3A9D80">${this.keyword}</span>`);
            }
        },

        closeDialog() {
            this.keyword = "";
            this.fastProcessData = []; // 快速发起
            this.classifyData = []; // 流程分类
            this.treeData = [];
            this.clickNodeUrl = ""; // 当前点击子节点的url
            this.classifyId = ""; // 当前点击的分类id
            this.collapseActiveNames = "1";
            this.dialogVisible = false;
        },
    },
};
</script>

<style scoped lang="scss">
.process-dialog {
    font-family: PingFangSC-Medium, PingFang SC;
    .dialog-header {
        height: 52px;
        text-align: center;
        position: relative;
        margin-bottom: 20px;
        background-color: #f9f9f9;
        .text {
            line-height: 52px;
            font-size: 16px;
            font-weight: 700;
            color: #000000;
        }
        .close-btn {
            top: 20px;
            right: 0px;
            position: absolute;
            cursor: pointer;
            color: #3a9d80;
            i {
                font-size: 14px;
                font-weight: 700;
            }
        }
    }
    .dialog-body {
        display: flex;
        height: 500px;
        overflow: hidden;
        .aside {
            width: 180px;
            border: 1px solid #e1e2e3;
            margin-right: 20px;
            .title {
                height: 40px;
                padding-left: 10px;
                line-height: 40px;
                background-color: #f9f9f9;
                font-weight: 700;
                border-bottom: 1px solid #e1e2e3;
            }
            .items {
                overflow: auto;
                padding: 0 10px;
                height: calc(100% - 40px);
                .el-collapse-item__header {
                    color: #333 !important;
                    .el-icon-time {
                        font-size: 14px;
                        font-weight: 700;
                    }
                    .collapse-title {
                        margin-left: 3px;
                        font-size: 14px;
                        font-weight: 700;
                    }
                }
                .empty-data {
                    color: #666;
                    text-align: center;
                }
                .item {
                    padding: 10px;
                    cursor: pointer;
                    overflow: hidden;
                    text-overflow: ellipsis; //内容超出部分以……结尾
                    white-space: nowrap; //制在一行内显示
                }
                .item:hover {
                    color: #3a9d80;
                    background-color: #f5f7fa;
                }
                .isActive {
                    color: #3a9d80;
                    background-color: #fff;
                }
                .isActive:hover {
                    color: #3a9d80;
                    background-color: #fff;
                }
            }
        }

        .main {
            flex: 1;
            border: 1px solid #e1e2e3;
            .right-title {
                height: 40px;
                padding: 0 10px;
                line-height: 40px;
                background-color: #f9f9f9;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-weight: 700;
                border-bottom: 1px solid #e1e2e3;
                .search-btn {
                    margin-left: 10px;
                }
            }
            .container {
                display: flex;
                height: calc(100% - 40px);
                .left-side {
                    width: 180px;
                    border-right: 1px solid #e1e2e3;
                    .items {
                        height: 100%;
                        overflow: auto;
                        padding: 12px;
                        .item {
                            font-size: 14px;
                            color: #333;
                            height: 32px;
                            line-height: 32px;
                            padding: 0 12px;
                            cursor: pointer;
                        }
                        .item:hover {
                            background-color: #f5f7fa;
                        }
                        .isActive {
                            color: #fff;
                            border-radius: 4px;
                            background: #54aa91;
                        }
                        .isActive:hover {
                            color: #fff;
                            border-radius: 4px;
                            background: #54aa91;
                        }
                    }
                }
                .right-side {
                    overflow: auto;
                    height: 100%;
                    flex: 1;
                    background-color: #eef7f7;
                }
            }
        }
    }
}
</style>
<style lang="scss">
.process-dialog {
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        margin: 0;
        padding: 0 32px 32px 32px;
        .aside {
            .items {
                .el-collapse {
                    padding: 0 10px;
                    border: unset;
                    .is-active {
                        color: #3a9d80;
                    }
                    .el-collapse-item__header {
                        border: unset;
                    }
                    .el-collapse-item__wrap {
                        border: unset;
                    }
                    .el-collapse-item__content {
                        padding-bottom: unset;
                    }
                }
            }
        }
        .main {
            .right-side {
                .el-tree {
                    background-color: #eef7f7;
                    .tree-current-title {
                        .title-prefix-icon {
                            width: 16px;
                            height: 14px;
                            margin-right: 8px;
                            display: inline-block;
                            background-size: 100%;
                            background-position: bottom;
                            background-repeat: no-repeat;
                        }
                        .process-icon {
                            background-image: url(../../../../../common/images/process-icon.png);
                        }
                        .file-icon {
                            background-image: url(../../../../../common/images/file-icon.png);
                        }
                    }
                    .el-tree-node__content {
                        color: #000;
                        height: 35px !important;
                        border-bottom: 1px solid #e1e2e3;
                    }
                    .is-current {
                        > .el-tree-node__content {
                            color: #fff !important;
                            background-color: #25a589 !important;
                            > .tree-current-title {
                                color: #fff !important;
                                .process-icon {
                                    background-image: url(../../../../../common/images/process-icon2.png);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
